/**
 * State colors for charts and tables
 */
export enum STATE_COLORS {
  demora = '#ff9900',
  'fuera-de-servicio' = '#707070',
  reserva = '#5D9CEC',
  operativo = '#22d983',
  red = '#ed5f5f',
  green = '#22d983',
  gray = '#707070',
  default = '#707070',
  isoutofpark = '#F05050',
}
